import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../resources/other-constants'
import './../styles/PrivacyDoc.sass'

const PrivacyPage: React.FC = () => {

    return (
        <>
            <div className="main-doc-content">
                <h3>INFORMATIVA PRIVACY</h3>
                <h4>Prenotazione Telematica degli Appuntamenti</h4>
                <h4>presso gli Sportelli della Camera di Commercio di Pisa</h4>
                <ul>
                    <li>
                        <p>
                            <b>Il Titolare del trattamento dei dati è la Camera di Commercio di Pisa</b>, con sede in Pisa, Piazza Vittorio Emanuele II, 5, 56125, e raggiungibile ai seguenti recapiti: - Tel. 050-512.111; Pec: cameracommercio@pi.legalmail.camcom.it
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Il Responsabile della protezione dei dati</b> nominato dalla Camera di Commercio di Pisa ai sensi degli artt. 37 e ss. del Regolamento UE 2016/679 è contattabile al seguente domicilio telematico pec: cameracommercio@pi.legalmail.camcom.it;
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Finalità del trattamento</b> - I dati personali da Lei forniti sono necessari per assicurare la corretta erogazione del servizio richiesto nella specie caratterizzato dalla prenotazione telematica di appuntamenti presso gli sportelli al pubblico della Camera di Commercio di Pisa. Il mancato rilascio del consenso non le consentirà di completare la procedura telematica di prenotazione.
                        </p>
                        <p>Le sono richiesti i seguenti Dati Personali: nome, cognome, e-mail e numero di telefono.</p>
                    </li>
                    <li>
                        <p>
                            <b>Modalità del trattamento</b> - Il trattamento è effettuato in modo da garantire la sicurezza e la riservatezza dei suoi dati ed è avviene con modalità esclusivamente informatiche;
                        </p>
                    </li>
                    <li>
                        <div>
                            <b>La base giuridica del trattamento</b> - La base giuridica del trattamento è costituita dalle seguenti disposizioni:
                            <ul>
                                <li>
                                    <p>Legge 29 dicembre 1993, n. 580 (Riordinamento delle camere di commercio, industria, artigianato e agricoltura) e leggi collegate</p>
                                </li>
                                <li>
                                    <p>Art. 6, Lett-a R.U. 679/2016 (consenso dell’interessato);</p>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p>
                            <b>I destinatari dei dati personali</b> sono i funzionari che operano presso il Titolare.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Comunicazione dei Dati Personali</b>
                        </p>
                        <p>
                            I dati personali da lei forniti non sono comunicati a Terzi e non saranno trasferiti in Stati membri dell’Unione Europea né in Stati terzi non appartenenti all’Unione Europea.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>La conservazione dei dati personali</b>
                        </p>
                        <p>
                            Il periodo di conservazione dei Dati Personali è pari ad un mese dal giorno dell’appuntamento.
                        </p>
                    </li>
                    <li>
                        <div>
                            <b>
                                Lei ha diritto:
                            </b>
                            <ul>
                                <li>
                                    <p>
                                        di chiedere al titolare del trattamento l&apos;accesso ai dati personali e la rettifica o la cancellazione degli stessi o la limitazione del trattamento che lo riguardano o di opporsi al loro trattamento, oltre al diritto alla portabilità dei dati;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        di ottenere la conferma dell&apos;esistenza o meno di dati personali che lo riguardano, anche se non ancora registrati, e la loro comunicazione in forma intelligibile;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        se ritiene che il trattamento dei dati personali effettuato attraverso questo servizio avvenga in violazione di quanto previsto dal Regolamento di proporre reclamo al Garante, come previsto dall&apos;art. 77 del Regolamento stesso, o di adire le opportune sedi giudiziarie (art. 79 del Regolamento);
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <p>
                    Per esercitare i suoi diritti può presentare la/le Sua/Sue richiesta/e con le seguenti modalità ai seguenti recapiti: via posta con raccomandata trasmessa indirizzata alla sede dell&apos;Ente Camerale; - via pec a: cameracommercio@pi.legalmail.camcom.it
                    Inesistenza di un processo decisionale automatizzato - La Camera di Commercio non adotta nel presente procedimento un processo automatizzato riconducibile alla profilazione di cui all&apos;articolo 22, paragrafi 1 e 4, Regolamento UE 679/2016
                </p>
                <ul>
                    <li>
                        <p>
                            <b>Ulteriori Informazioni All’Interessato</b>
                        </p>
                        <p>
                            La Camera di Commercio, per l’erogazione del Servizio, si avvale di un Responsabile esterno appositamente nominato ai sensi dell’art. 28 del Regolamento Europeo n. 679/2016.
                        </p>
                    </li>
                </ul>
                <div className='medium-margin-top-container'>
                    <Link to={ROUTES.HOMEPAGE_ROUTE} className='primary-button'>Indietro</Link>
                </div>
                {/**
                    <>
                        <div className='horizontal-line' />
                        <p>Pisa, 22-03-2022</p>
                        <div className='horizontal-line' />
                        <p>Camera di Commercio di Pisa - Piazza Vittorio Emanuele II, 5  - 56125 Pisa</p>
                        <p>C.F. 80000430506 - P.I. 00924980501 Tel. +39 050 512.111 - Fax +39 050 512.250</p>
                        <p>Posta elettronica certificata (PEC): cameracommercio@pi.legalmail.camcom.it</p>
                    </>
                */}
            </div>
        </>
    )
}

export default PrivacyPage
